var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirecrackersAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00393 2C2.44948 2 2 2.43049 2 2.96152V10.3579C2 10.7862 2.54069 11.0007 2.85691 10.6979L4.83955 8.79899L11.9384 15.598C12.0651 15.7193 12.2172 15.8014 12.3783 15.8444L18.5849 21.7888C18.879 22.0704 19.3557 22.0704 19.6497 21.7888C19.9438 21.5072 19.9438 21.0506 19.6497 20.7689L13.8045 15.1706L15.2495 13.7866L17.079 15.5387C18.2047 16.617 20.03 16.617 21.1557 15.5387C22.2814 14.4606 22.2814 12.7126 21.1558 11.6344L20.6537 11.1535C20.3597 10.8719 19.8829 10.8718 19.5889 11.1534C19.2948 11.4351 19.2948 11.8917 19.5888 12.1733L20.0909 12.6542C20.6285 13.1691 20.6285 14.004 20.0909 14.5189C19.5532 15.0339 18.6815 15.0339 18.1438 14.5189L16.3048 12.7576C16.5858 12.3819 16.5501 11.8561 16.1978 11.5186L9.09888 4.7196L11.0815 2.82071C11.3977 2.51785 11.1738 2 10.7266 2H3.00393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirecrackersAlt4);
export default __webpack_public_path__ + "static/media/firecrackers-alt-4.0a16aca6571eb723480adfb0bb3e57a4.svg";
export { ForwardRef as ReactComponent };